var _path, _path2;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var LogOut = function LogOut(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: [_path || (_path = /*#__PURE__*/_jsx("path", {
      d: "M5 3a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h7a3 3 0 0 0 3-3v-2a1 1 0 1 0-2 0v2a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v2a1 1 0 1 0 2 0V6a3 3 0 0 0-3-3H5Z",
      fill: "none",
      className: "tw-fill-current"
    })), _path2 || (_path2 = /*#__PURE__*/_jsx("path", {
      d: "M18.707 8.293a1 1 0 1 0-1.414 1.414L18.586 11H7a1 1 0 1 0 0 2h11.586l-1.293 1.293a1 1 0 0 0 1.414 1.414l3-3a1 1 0 0 0 0-1.414l-3-3Z",
      fill: "none",
      className: "tw-fill-current"
    }))]
  });
};
export default LogOut;